import CityPageTemplate from "../city-template/CityPageTemplate";
import { mindenConfig } from "./data";

export default function MindenPage() {
  return <CityPageTemplate config={mindenConfig} />;
}